<template>
  <div class="logo-ntteast">
    <img
      v-if="logoPath"
      :src="logoFullUrl"
      :alt="logoAlt || ''"
    />
    <Retina
      v-else
      dir="common"
      :name="imgName"
      extension="svg"
      width="141"
      height="32"
      alt="NTT東日本"
    />
  </div>
</template>

<script>
import Retina from '@/components/img/Retina';

export default {
  name: 'NttEast',
  props: [ 'type', 'logoPath', 'logoAlt' ],
  computed: {
    imgName() {
      return this.type ? `NTT_EAST_EN_CorporateSymbol_A1_4C-${ this.type }` : 'NTT_EAST_EN_CorporateSymbol_A1_4C';
    },
    logoFullUrl() {
      return process.env.VUE_APP_IMAGE_BASE_URL + this.logoPath;
    }
  },
  components: {
    Retina
  },
}
</script>

<style lang="scss" scoped>
.logo-ntteast {
  width: 150px;
  height: 32px;
  img {
    object-fit: contain;
    object-position: left center;
    width: 100%;
    height: 100%;
  }
  @media screen and (max-width: $sp_point) {
    width: 126px;
    height: 28px;
  }
}
</style>
